module.exports = __webpack_public_path__ + "static/media/authy.6431d0d7.svg";